import { formatCurrencyWithNumberToSymbolWithNumber } from "@ui/utils/formatter"
import { DEFAULT_CURRENCY } from "src/constants"

export const getTeamUserDisableSuccessMessage = (returned: number) =>
	returned > 0
		? `Buyer removed. ${formatCurrencyWithNumberToSymbolWithNumber(
				returned,
				DEFAULT_CURRENCY
			)} returned to the company account.`
		: "Buyer removed. No balance was returned."
